import React, { useContext, useEffect, useState } from 'react';
import firebase from './lib/firebase.prod';
import Spinner from './components/layout/spinner/Spinner';
import { CircularProgress } from '@material-ui/core';

export const AuthContext = React.createContext();

export const AuthProvider = ({ children }) => {
	const [currentUser, setCurrentUser] = useState(null);
	const [pending, setPending] = useState(true);

	useEffect(() => {
		firebase.auth().onAuthStateChanged((user) => {
			setCurrentUser(user);
			setPending(false);
		});
	}, []);

	if (pending) {
		return (
			<CircularProgress
				style={{ position: 'absolute', left: '50%', top: '15%' }}
			/>
		);
	}

	return (
		<AuthContext.Provider
			value={{
				currentUser,
			}}
		>
			{children}
		</AuthContext.Provider>
	);
};
